import { useMutation } from "@apollo/client"
import { TOURNAMENT_REGISTER } from "../queries/tournamentRegister"

export interface TournamentRegisterInput {
  name: string
  description: string
  image?: string
  eventUrl?: string
  addressId: number
  gameId: number
  typeId: number
  formatId: number
  startDate: string
  validDates: number
}

export const useTournamentRegister = () => {
  const [tournamentRegister, { data, loading, error }] = useMutation<{
    TournamentRegister: {
      status: {
        success: boolean
        name: string
        detail: string
      }
      tournament: {
        id: number
        name: string
        urlView: string
      }
    }
  }>(TOURNAMENT_REGISTER)

  const registerTournament = async (input: TournamentRegisterInput) => {
    const response = await tournamentRegister({
      variables: { TournamentRegisterInput: input },
    })
    return response.data?.TournamentRegister
  }

  return {
    registerTournament,
    data: data?.TournamentRegister,
    loading,
    error,
  }
}
